import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: 'home',
        loadChildren: () => import ('./pages/home/home.module').then((m) => m.HomePageModule),
    },
    {
        path: 'login',
        loadChildren: () => import ('./pages/login/login.module').then((m) => m.LoginPageModule),
    },
    {
        path: 'about',
        loadChildren: () => import ('./pages/about/about.module').then((m) => m.AboutPageModule),
    },
    {
        path: 'sync-log',
        loadChildren: () => import ('./pages/sync-log/sync-log.module').then((m) => m.SyncLogPageModule),
    },
    {
        path: 'activity-page',
        loadChildren: () => import ('./pages/activity-page/activity-page.module').then((m) => m.ActivityPagePageModule),
    },
    {
        path: 'add-activity',
        loadChildren: () => import ('./pages/add-activity/add-activity.module').then((m) => m.AddActivityPageModule),
    },
    {
        path: 'calendar-modal',
        loadChildren: () =>
            import ('./pages/calendar-modal/calendar-modal.module').then((m) => m.CalendarModalPageModule),
    },
    {
        path: 'camera',
        loadChildren: () => import ('./pages/camera/camera.module').then((m) => m.CameraPageModule),
    },
    {
        path: 'dashboard',
        loadChildren: () => import ('./pages/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
    },
    {
        path: 'blank',
        loadChildren: () => import ('./pages/blank/blank.module').then((m) => m.BlankPageModule),
    },
    {
        path: 'forgot-password',
        loadChildren: () =>
            import ('./pages/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordPageModule),
    },
    {
        path: 'gallery',
        loadChildren: () => import ('./pages/gallery/gallery.module').then((m) => m.GalleryPageModule),
    },
    {
        path: 'home',
        loadChildren: () => import ('./pages/home/home.module').then((m) => m.HomePageModule),
    },
    {
        path: 'list',
        loadChildren: () => import ('./pages/list/list.module').then((m) => m.ListComponentPageModule),
    },
    {
        path: 'note-pen-page',
        loadChildren: () => import ('./pages/note-pen-page/note-pen-page.module').then((m) => m.NotePenPagePageModule),
    },
    {
        path: 'storage',
        loadChildren: () => import ('./pages/storage/storage.module').then((m) => m.StoragePageModule),
    },
    {
        path: 'work-order',
        loadChildren: () => import ('./pages/work-order/work-order.module').then((m) => m.WorkOrderPageModule),
    },
    {
        path: 'leaflet-display',
        loadChildren: () =>
            import ('./pages/leaflet-display/leaflet-display.module').then((m) => m.LeafletDisplayPageModule),
    },
    {
        path: 'settings',
        loadChildren: () => import ('./pages/app-settings/app-settings.module').then((m) => m.AppSettingsModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            paramsInheritanceStrategy: 'always',
            enableTracing: false,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
